import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/element-variables.scss';

import jm from 'vue-jsmind';
import locale from 'element-ui/lib/locale/lang/zh-CN';
import App from './App';
import store from './store';
import router from './router';
import theme from '../static/theme';
import './permission'; // permission control

import 'swiper/dist/css/swiper.min.css';
import 'swiper/dist/js/swiper.min';

import '@/styles/index.scss'; // global css
import * as filters from './filters'; // global filters
import '@babel/polyfill';
import { patch } from './utils/patch';

// set ElementUI lang to EN
Vue.use(ElementUI, { locale });
Vue.use(jm);

// eslint-disable-next-line no-undef
Vue.use(VueMarkdown);

Vue.prototype.$theme = theme;
Vue.config.productionTip = false;

// 锚点
Vue.directive('anchor', {
    inserted(el, binding) {
        el.onclick = function () {
            // if (router.currentRoute.name === 'talentDetail') {
            //   let scrollTops = 0;
            //   if (binding.value === 'risk') {
            //     scrollTops = Number($('#anchor-awards').attr('scroll-top')) + 80;
            //   } else if (binding.value === 'qualifications') {
            //     scrollTops = Number($('#anchor-awards').attr('scroll-top')) + 130;
            //   } else {
            //     scrollTops = $('#anchor-' + binding.value).attr('scroll-top');
            //   }
            //   $('.company-detail-body').animate({scrollTop: Number(scrollTops) + 1}, 300);
            // } else {
            //   let scrollTops = $('#anchor-' + binding.value).attr('scroll-top');
            //   $('.company-detail-body').animate({scrollTop: Number(scrollTops) + 1}, 300);
            // }
            // eslint-disable-next-line no-undef
            const scrollTops = $(`#anchor-${binding.value}`).attr('scroll-top');
            // eslint-disable-next-line no-undef
            $('.company-detail-body').animate({ scrollTop: Number(scrollTops) + 1 }, 300);
        };
    },
});

// 过滤器
Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key]);
});

router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    if (isChunkLoadFailed) {
        window.location.reload();
    } else {
        console.log(error);
    }
});

new Vue({
    el: '#app',
    router,
    store,
    render: (h) => h(App),
});

patch();



// WEBPACK FOOTER //
// ./src/main.js